<div style="padding: 0% 12%">
  <h2>Session time out</h2>
  <p>Please login and come back again</p>
  <cds-button (click)="loginWithSSO()">Login</cds-button>
</div>
